import { http } from "@/utils/index";

/**
 * 获取欧洲专线完整数据
 */
export function getEuropeLineData(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/europe-line/data", {
    params
  });
}

/**
 * 检查欧洲专线数据是否已初始化
 */
export function checkEuropeLineInit(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/europe-line/check-init", {
    params
  });
}

/**
 * 获取欧洲专线统计数据
 */
export function getEuropeLineStats(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/europe-line/stats", {
    params
  });
}
